import { http } from './config'

export default {
  salvarvenda:(venda) => {
    return http.post('salvar_venda.php',(venda));
  },
  /*salvarvendaentrega:(venda) => {
    return http.post('salvar_venda.php',(venda));
  },
  salvarvendaretirada:(venda) => {
    return http.post('salvar_venda.php',(venda));
  },*/
  listarvenda:() => {
    return http.get('vendas_pedidos.php')
  },
  listarpedidosvenda:(venda) => {
    return http.get('vendas_selecao.php',(venda))
  },
  buscacodigo:(venda) => {
    return http.get('vendas_selecao.php',(venda))
  }  
}